




































import { Vue, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import Item from "./personCenter/item.vue";
import { myUpload } from "../../http/login.api";
import { deleteGoods } from "@/http/goods";
@Component({
  components: {
    Item
  }
})
export default class PersonCenter extends Vue {
  @State("User") User: any;
  // goodsList = Array.from({ length: 10 }).map((ele) => ({
  //   title: "协和医院工作证",
  //   hidden: Math.random() > 0.5
  // }));
  get userInfo() {
    return this.User.user || {};
  }
  oldObjects = [];
  mrStyles = [];
  async publish(flag: boolean) {
    await myUpload();
    flag ? this.$router.push("/old/add") : this.$router.push("/grace/add");
  }

  getData() {
    myUpload().then(res => {
      this.oldObjects = res.oldObjects;
      this.mrStyles = res.mrStyles;
    });
  }
  onSubmit() {
    console.log(2);
  }

  mounted() {
    this.getData();
  }
}
